import ExclamationTriangleIcon from "@heroicons/react/24/outline/ExclamationTriangleIcon";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";

export const BannerWrapper = styling("div")((props) => ({
  backgroundColor: "rgba(254, 231, 229, 1)",

  display: "flex",
  justifyContent: "center",
  gap: "0.5rem",

  fontSize: "1rem",
  lineHeight: "24px",
  letterSpacing: "0.15px",

  padding: "1rem 3.2rem",
  marginTop: "0",
  alignItems: "center",

  "@media (max-width: 640px)": {
    fontSize: "0.875rem",
    gap: "1.5rem",
  },
}));

export const TextContainer = styling("div")({
  display: "flex",
  alignItems: "center",

  "@media (max-width: 640px)": {
    flexDirection: "column",
  },
});

export const BoldText = styling("span")({
  fontWeight: "600",
});

export const DangerIcon = styling(ExclamationTriangleIcon)({
  color: Color.reject,
  width: "24px",
  height: "24px",
});
